import { Injectable, inject } from "@angular/core";
import { IToggle, LocalStorageProvider } from "unleash-proxy-client";

import { FeatureFlagsFacade } from "../state/feature-flags.facade";

/**
 * By default, Unleash client stores the feature toggles in local storage.
 * This service extends the default storage provider to sync the feature toggles
 * with the FeatureFlagsFacade.
 */
@Injectable({
  providedIn: "root",
})
export class UnleashStorageProviderService extends LocalStorageProvider {
  private readonly featureFlagsFacade = inject(FeatureFlagsFacade);

  /** The key by which Unleash client stores feature toggles in the local storage */
  private readonly TOGGLES_STORE_KEY = "repo";

  public constructor() {
    super();
  }

  public override async save(name: string, data: any): Promise<void> {
    if (name === this.TOGGLES_STORE_KEY) {
      if (!Array.isArray(data)) return;

      const featureFlags = data
        .filter((datum) => this.isFeatureToggle(datum))
        .filter((featureToggle) => featureToggle.enabled)
        .map((featureToggle) => featureToggle.name);

      this.featureFlagsFacade.setFeatureFlagsEnabled(featureFlags);
    }

    super.save(name, data);
  }

  private isFeatureToggle(datum: any): datum is IToggle {
    if (!(datum instanceof Object)) {
      return false;
    }

    if (!("name" in datum) || typeof datum.name !== "string") {
      return false;
    }

    if (!("enabled" in datum) || typeof datum.enabled !== "boolean") {
      return false;
    }

    return true;
  }
}
